<template>
	<div class="orders-skeleton" aria-busy="true">
		<span class="orders-skeleton__status" role="status">Loading your orders</span>
		<Skeleton v-for="row in 3" :key="row" height="--size-96" radius="--size-24" />
	</div>
</template>

<script setup lang="ts">
import { Skeleton } from '@simple-life-app/growth-ui-kova'

/**
 * The Orders list while its first read is out (spec §6.1). No Figma frame exists for it, and the ticket asks for a
 * loading state, not the list's shape: three DS `Skeleton` rows, card-round and 8 apart like the cards. The renewal
 * feed never holds it. Screen readers get one "Loading your orders"; the rows are the DS's own `aria-hidden`.
 */
</script>

<style scoped>
.orders-skeleton {
	display: flex;
	flex-direction: column;
	gap: var(--size-8);
}

/* Read by screen readers, not drawn. */
.orders-skeleton__status {
	position: absolute;
	width: 1px;
	height: 1px;
	overflow: hidden;
	clip-path: inset(50%);
	white-space: nowrap;
}
</style>
